import React from 'react';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

const ProjectsListHeader = ({ canAdd = false, companyId = '', subcompanyId = '', t }) => {
  return (
    <Common.Header title={t('projects.title')}>
      <div className="btn-group pull-right">
        {canAdd && (
          <Form.Link
            to={createRoute(companyId, subcompanyId, 'projects/add')}
            className="btn btn-info"
          >
            {t('actions.add')}
          </Form.Link>
        )}
      </div>
    </Common.Header>
  );
};

export default translate()(ProjectsListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/components/list/ProjectsListHeader.js